<template>
  <div class="mainbody sha-info-page">
    <div class="sha-info-hero">
      <h1>Terms of Use</h1>
      <nav class="sha-info-tabs" aria-label="Information pages">
        <router-link to="/delivery-locations" class="sha-info-tab" exact-active-class="active">Delivery Area</router-link>
        <router-link to="/contact-us" class="sha-info-tab" exact-active-class="active">Contact Us</router-link>
        <router-link to="/policy" class="sha-info-tab" exact-active-class="active">Privacy Policy</router-link>
        <router-link to="/terms-condition" class="sha-info-tab" exact-active-class="active">Terms of Use</router-link>
      </nav>
    </div>
    <div class="container-fluid">
      <div class="col-md-12">
        <div class="bg-fix">
          <div class="text-center">
            <h2 class="base-color">
              Terms &amp; Condition
            </h2>
            <img src="@/assets/images/icons/border.png" alt="">
          </div>
          <h3 class="green-color">
            <i class="fa fa-circle-thin">
            </i>
            Privacy Policy
          </h3>
          <p>
            1.1. Welcome to shahpremiumfoods.com . Shahpremiumfoods provides access to the website or the mobile application/app or any other media to you subject to the terms and conditions (“Terms”) set out on this page. By using the Website, you, a registered or guest user in terms of the eligibility criteria set out herein (“User”) agree to be bound by the Terms. Please read them carefully as your continued usage of the Website, you signify your agreement to be bound by these Terms. If you do not want to be bound by the Terms, you must not subscribe to or use the Website or our services.
          </p>
          <p>
          1.2. By impliedly or expressly accepting these Terms, you also accept and agree to be bound by Shahpremiumfoods Policies (including but not limited to Privacy Policy available at [website privacy policy URL]) as amended from time to time.
        </p>
          <p>
            1.3. The contents set out herein form an electronic record in terms of তথ্য ও যোগাযোগ প্রযুক্তি আইন, ২০০৬ (Information & Communication Technology Act, 2006) and rules there under as applicable and as amended from time to time. As such, this document does not require any physical or digital signatures and forms a valid and binding agreement between the Website and the User
          </p>
          <p>
            1.4. By accepting the Terms or using or transacting on the Website, the User irrevocably declares and undertakes that he/she is of legal age i.e. 12 years or older and capable of entering into a binding contract and such usage shall be deemed to form a contract between the Website and such User to the extent permissible under applicable laws.
          </p>
            Your Account and Responsibilities
<br>
            Any person may access the Website either by registering to the Website or using the Website as a guest. However, a guest user may not have access to all sections of the Website including certain benefits/promotional offers, which shall be reserved only for the purpose of registered Users, and which may change from time to time at the sole discretion of the Website.
<br>
            If you wish to register your account with the Website, you shall be required to create an account by registering with a valid Bangladeshi mobile number and/or with your Facebook account or your email address or by filling in the details prescribed in the Website registration form. You will then receive a password or one-time PIN with which you can login to the website to place orders.
<br>
            If you use the website, you will be responsible for maintaining the confidentiality of your username and password and you will be responsible for all activities that occur under your username and you will be under the obligation to restrict access to your computer or mobile phone to prevent unauthorized access to your account. You should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be, used in an unauthorized manner. You agree that if you provide any information that is untrue, inaccurate, not current or incomplete or we have reasonable grounds to suspect that such information is untrue, inaccurate, not current or incomplete, or not in accordance with this Terms of Use, we have the right to suspend or terminate your membership on the website.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const $ = require('jquery');
  window.$ = $;
  $(function () {
    $(window)
      .scroll(function () {
        $('nav')
          .toggleClass('scrolled', $(this)
            .scrollTop() > 50);
      });

  });
  import axios from 'axios';

  export default {
    data() {
      return {
      };
    },
    created: function () {

    }
  };
</script>
